import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../../../core/layout/Card';
import Separator from '../../../../core/layout/Separator';
import MasteryTestItemHistoryBreadcrumbs from './MasteryTestItemHistoryBreadcrumbs';
import MasteryTestItemHistoryDetail from './MasteryTestItemHistoryDetail';
import ItemHistoryListContainer from '../ItemHistoryListContainer';

const MasteryTestItemHistoryScene = (props) => (
  <div>
    <MasteryTestItemHistoryBreadcrumbs masteryTestItem={props.masteryTestItem} fetching={props.fetching} />
    <Separator />
    <MasteryTestItemHistoryDetail masteryTestItem={props.masteryTestItem} fetching={props.fetching} />
    <Card title="History" loading={props.fetching}>
      <ItemHistoryListContainer itemId={props.masteryTestItem.item.id} />
    </Card>
  </div>
);

MasteryTestItemHistoryScene.propTypes = {
  fetching: PropTypes.bool,
  masteryTestItem: PropTypes.shape({
    order: PropTypes.number.isRequired,
    masteryTest: PropTypes.shape({
      id: PropTypes.string.isRequired,
      modulePercentageToActive: PropTypes.number.isRequired,
      module: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        course: PropTypes.shape({
          name: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
    item: PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

MasteryTestItemHistoryScene.defaultProps = {
  fetching: false,
};

export default MasteryTestItemHistoryScene;
